import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '../../helper/util';



@Pipe({name: 'phone'})
export class PhonePipe implements PipeTransform {

    transform(val: string) {
        if ( Utilities.stringEmpty(val)){
            return '';
        }
        return `(${val.slice(0, 3)}) ${val.slice(3, 6)}-${val.slice(6, 10)}`;
    }
}
